import { Company } from "@/components/CompanyCard";
import { Building2 } from "lucide-react";
import { Link } from "react-router-dom";
import { EntityList } from "@/components/common/EntityList";
import { useTranslation } from "react-i18next";

interface CompaniesListProps {
  companies: Company[];
  filteredCompanies: Company[];
  isLoading: boolean;
}

export const CompaniesList = ({
  companies,
  filteredCompanies,
  isLoading
}: CompaniesListProps) => {
  const { t } = useTranslation();
  const columns = [
    {
      key: "name",
      header: t("companies.header"),
      cell: (company: Company) => (
        <Link to={`/companies/${company.id}`} className="hover:underline flex items-center gap-2">
          <Building2 className="h-4 w-4 text-gray-400" />
          {company.name}
        </Link>
      ),
    },
    {
      key: "address",
      header: t("companies.address"),
      cell: (company: Company) => company.address || "-",
    },
    {
      key: "assignee",
      header: t("companies.assignee"),
      cell: (company: Company) => company.assignee || "-",
    },
    {
      key: "notes",
      header: t("companies.notes"),
      cell: (company: Company) => (
        <div className="truncate max-w-[200px]">{company.notes || "-"}</div>
      ),
    },
  ];

  return (
    <EntityList
      data={filteredCompanies}
      columns={columns}
      isLoading={isLoading}
      emptyMessage={t("companies.empty")}
      basePath="/companies"
    />
  );
};
